import React from "react";
import {
  Box,
  Card,
  CardContent,
  Typography,
  Stack,
} from "@mui/material";
import { CasinoOutlined as RevolverIcon } from "@mui/icons-material";
import { colors, borderRadiusPx } from "../../../../../theme";
import { LOTTERY_NAMES } from "../../../../../static/Constants";
import SpinWheel from "../../../../Components/SpinWheel/SpinWheel";

const SpinWheelView = ({
  lotteryData,
  partner,
  partnerLogoData,
}) => {
  return (
    <Card
      sx={{
        borderRadius: borderRadiusPx.lg,
        border: `1px solid ${colors.slate[200]}`,
        boxShadow: "0 4px 15px rgba(0,0,0,0.03)",
        bgcolor: "#ffffff",
        mb: 4,
      }}
    >
      <CardContent sx={{ p: { xs: 2.5, md: 3.5 } }}>
        <Stack
          direction={{ xs: "column", sm: "row" }}
          justifyContent="space-between"
          alignItems={{ xs: "flex-start", sm: "center" }}
          spacing={2}
          sx={{ mb: 2.5 }}
        >
          <Box>
            <Typography
              variant="h6"
              sx={{
                fontWeight: 700,
                color: colors.slate[900],
                display: "flex",
                alignItems: "center",
                gap: 1,
              }}
            >
              <RevolverIcon sx={{ color: colors.primary.main }} />
              {`${LOTTERY_NAMES.SPINBET} Live Wheel`}
            </Typography>
            <Typography variant="body2" sx={{ color: colors.slate[500], mt: 0.25 }}>
              Choose your lucky segment and spin the wheel for instant on-chain rewards!
            </Typography>
          </Box>
        </Stack>

        <Box sx={{ maxWidth: 680, mx: "auto", my: 2 }}>
          <SpinWheel
            lotteryData={lotteryData}
            partner={partner}
            partnerLogo={partnerLogoData}
          />
        </Box>
      </CardContent>
    </Card>
  );
};

export default SpinWheelView;
